import React, { useEffect, useState } from "react";
import CreateSkill from "../createSkill";

const CreateSkillBot = () => {


    return (
        <div >
            <CreateSkill
                botType={'configure'}></CreateSkill>
        </div>
    );
};

export default CreateSkillBot;